import React from 'react';
import { ThemeProvider, DashboardProvider, PageProvider } from '@contexts';
import Router from './router';
import GlobalStyle from '@theme/GlobalStyle';

function App() {
  return (
    <ThemeProvider>
      <GlobalStyle />
      <PageProvider>
        <DashboardProvider>
          <Router />
        </DashboardProvider>
      </PageProvider>
    </ThemeProvider>
  );
}

export default App;